export default __webpack_public_path__ + "static/media/logo-innovate.d923aa35.svg";